import React from 'react';
import '../List/List.esm.js';
import { ListItem } from '../List/ListItem.esm.js';

const SelectAllListItem = (props) => {
    const { highlightedIndex, selectedItems, selectAllItem, getItemProps } = props;
    return (React.createElement(ListItem, { dataMetrics: "select-all", dataTestId: "select-all", active: highlightedIndex === 0, checked: selectedItems.includes(selectAllItem), hasCheckbox: true, ...selectAllItem, ...getItemProps({
            disabled: selectAllItem.disabled,
            item: selectAllItem,
            index: 0
        }), style: { minWidth: '100%' } }, selectAllItem.value));
};

export { SelectAllListItem };
//# sourceMappingURL=SelectAllListItem.esm.js.map
